<div class="container pt--lg-96 pb--lg-96 pt--48 pb--48" isInViewport (isInViewport)="reveal($event)">
    <h2 class="mat-text-primary text-primary text-center mt--lg-96 mt--48 mb--lg-96 mb--48">La tua azienda ha un grande potenziale produttivo</h2>
    <div class="d-flex flex-lg-row flex-column pt--lg-48 pb--lg-96 pt--24 pb--48 position-relative">
        <div class="promo-box flex-1 pl--16 pr--16 pl--lg-0 pr--lg-0" [class.active]="showPromo">
            <ng-container *ngIf="showPromo">
            <h1 [@fadeInLeft]="{value:'' , params: {delay: '500ms'}}" (@fadeInLeft.done)="revealText($event)"  class="h3">Ottimizza il tuo modo di lavorare con Playmetrics</h1>
           <div class="text-promo" *ngIf="showText">
            <ngx-typed-writer 
            [strings]="['Analizza il tuo processo produttivo col l\'IA e scopri come migliorare il flusso in maniera <b>pi&ugrave; efficiente ed intelligente</b>.<br />Ottimizza tempi e procedure per una maggiore produttivit&agrave;']"
            [isHTML]="true" 
            [startDelay]="250" 
            [cursorChar]="''" 
            [showCursor]="false" 
            [typeSpeed]="10" 
            [loop]="false" 
            (completeLoop)="revealAction()"> </ngx-typed-writer>
            </div>
            <!-- <div [@fadeInLeft]="{value: '', params: {delay: '700ms'}}" class="text-default">Analizza il tuo processo produttivo e scopri come migliorare il flusso in maniera piu efficiente ed intelligente. Ottimizza tempi e procedure per una maggiore produttività</div> -->
            <button *ngIf="showAction" [@fadeInLeft] class="mt--24" mat-flat-button color="primary" (click)="goToPlaymetrics()">Scopri di più</button>
            </ng-container>
        </div>

        <div class="image-box d-flex flex-column align-items-center fw flex-1" >
            <ng-container *ngIf="isInView">
                <div class="laptop-screen" [@flipScreen] (@flipScreen.done)="revealPromo($event)" >
                    <img [ngSrc]="'/images/products/laptop-screen.webp'" height="540" width="1200" alt="Playmetrics" class="img-responsive">
                </div>
            </ng-container>
            <div class="laptop-keyboard mb--16 mb--lg-0">
                <img  [ngSrc]="'/images/products/laptop-keyboard.webp'" height="50" width="1200" alt="Playmetrics" class="img-responsive">
            </div>
        </div>
    </div>
</div>
